<div [ngClass]="{ 'spinner': true, 'spinner-height-50': heightCenter }">
    <div class="layout">
        <div class="logo-menu mt-3 mb-3">
            <img width="135vw" src="./assets/images/logos/logo_15.png" alt="logo_classind" />
        </div>
        <span class="mat-caption text-secondary">{{ 'TRADUCAO' | translate: msgSpinner }}</span>
        <mat-progress-bar width="100vw" mode="indeterminate"></mat-progress-bar>
    </div>
</div>
